import React from "react";

import { Col, Link, Row, Svg } from "components";

export const AccountLogo: React.FC = () => (
  <Row>
    <Col className="left margin-bottom-200">
      <Link to="https://www.klim.eco" mixpanelText="klim-logo" target="_blank">
        <Svg svgName="logos/klim_logo_text_black" width={75} height={32} />
      </Link>
    </Col>
  </Row>
);
